import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { QuestionCircle, QuestionCircleType } from '../../CircleText/CircleText';
import { colorsV2 } from '../../colors-v2';
import { SubText } from '../../Typography';

const CircleBlankWrapper = styled.span`
  display: inline-grid;
  grid-template-columns: 24px 88px;
  grid-column-gap: 8px;
  margin: 0 8px;
`;

const Blank = styled.div`
  width: 88px;
  height: 24px;
  border-bottom: 2px solid ${colorsV2.gray50};
`;

interface CircleBlankProps extends React.HTMLAttributes<HTMLDivElement> {
  circleText?: string | number;
}

const CircleBlank = (props: CircleBlankProps) => {
  const { circleText } = props;

  return (
    <CircleBlankWrapper>
      <QuestionCircle className={cl(QuestionCircleType.GRAY_100, 'option-circle')}>
        <SubText>{circleText}</SubText>
      </QuestionCircle>
      <Blank />
    </CircleBlankWrapper>
  );
};

export default React.memo(CircleBlank);
